import React from 'react';

import { camelCase } from 'lodash';

import Dropdown from 'components/dropdown';

import type { ListingStatusOption } from './types';

interface Props {
  listingType: string;
  setStatus: (status: { key: string; label: string }) => void;
  status: { key: string; label: string };
  statusOptions: ListingStatusOption[];
}

export default function StatusSelect({ listingType, setStatus, status, statusOptions }: Props) {
  return (
    <Dropdown label={status.label}>
      {statusOptions.filter(option => option.listingTypes.includes(listingType)).map(option => (
        <Dropdown.Item
          key={camelCase(option.key)}
          label={option.label}
          onClick={() => setStatus(option)}
        />
      ))}
    </Dropdown>
  );
}
